import React from 'react';
import FacilityStore from '../../stores/FacilityStore';
import ViewerStore from '../../stores/ViewerStore';

declare var InovxLoader: any;

interface AssetInformationButtonProps {
    onShowAssetInformation: () => void;
}

const hasSelectedAsset = () => {
    const selectedHierarchyItems = ViewerStore.getSelectedHierarchyItems();

    if (selectedHierarchyItems?.length === 1) {
        return true;
    }

    return !!FacilityStore.getAssetById(ViewerStore.getSelectedAsset());
};

const AssetInformationButton: React.FC<AssetInformationButtonProps> = ({ onShowAssetInformation }) => {
    const [isAssetSelected, setIsAssetSelected] = React.useState(hasSelectedAsset);

    React.useEffect(() => {
        const handleSelectionChange = () => setIsAssetSelected(hasSelectedAsset());

        FacilityStore.addChangeListener(handleSelectionChange);
        ViewerStore.addChangeListener(handleSelectionChange);

        return () => {
            FacilityStore.removeChangeListener(handleSelectionChange);
            ViewerStore.removeChangeListener(handleSelectionChange);
        };
    }, []);

    return (
        <button
            id="asset-info-button"
            type="button"
            title={InovxLoader.t('facility:viewer.showAssetInformation')}
            onClick={() => isAssetSelected && onShowAssetInformation()}
        >
            <span className={`content-layer-icons speeddial-icon-asset-info ${!isAssetSelected ? 'incactive-icon' : ''}`}></span>
        </button>
    );
};

export default AssetInformationButton;
